import { products, printAreas } from '../data/products.js';
import { priceCart } from './couponPricing.js';
import { roundMoney } from './pricingConstants.js';

export const PRINTED_CAPS_PRODUCT_PATH = '/product/KR2020';
export const PRINTED_CAPS_OFFER_VERSION = 'kr2020-quantity-v1';
export const PRINTED_CAPS_QUOTE_CONFIGURATION = Object.freeze({
  sku: 'KR2020',
  color: 'כחול נייבי',
  size: 'adult',
  areaKey: 'cap_front',
  method: 'print',
});

export const printedCapsQuoteCopy = Object.freeze({
  heading: 'כמה יעלו הכובעים עם ההדפס?',
  configuration: 'דוגמה לחישוב: כובע בסיסי KR2020, כחול נייבי, מידת מבוגרים והדפסה אחת בחזית.',
  included: 'המחירים כוללים את הכובע, הדפסה קדמית אחת ומע״מ. באיסוף עצמי אין תוספת משלוח.',
  discounts: 'הדוגמאות מחושבות ללא הנחה, קופון או הטבה לפי אופן התשלום. הסכום הסופי מחושב בסיכום ההזמנה לפי הבחירות שלכם.',
  availability: 'דוגמאות המחיר אינן אישור מלאי. בדף המוצר בוחרים צבע, מידה וכמות; כל דגם ואפשרויותיו נבדקים בנפרד.',
});

// A named example configuration, not a stock assertion or a selected order.
// Both collection and delivery totals use the current cart pricing contract.
export function buildPrintedCapsQuantityOffer(product = products.find(({ sku }) => sku === 'KR2020')) {
  const configuration = PRINTED_CAPS_QUOTE_CONFIGURATION;
  if (product?.sku !== configuration.sku
    || !product.colors?.includes(configuration.color)
    || !product.sizeRange?.includes(configuration.size)
    || !product.activePrintAreas?.includes(configuration.areaKey)) return null;

  const examples = [];
  for (const quantity of [20, 50, 100]) {
    const item = {
      productSku: configuration.sku,
      sizeMatrices: { [configuration.color]: { [configuration.size]: quantity } },
      selectedPrintAreas: [{ areaKey: configuration.areaKey, method: configuration.method }],
      discountClaimed: false,
    };
    const options = { cartItems: [item], couponCode: '', discountClaimed: false, paymentMethod: '' };
    const collection = priceCart({ ...options, withDelivery: false });
    const delivery = priceCart({ ...options, withDelivery: true });
    if (!collection.ok || !delivery.ok
      || !Number.isFinite(collection.paymentTotal) || collection.paymentTotal <= 0
      || !Number.isFinite(delivery.paymentTotal) || delivery.paymentTotal < collection.paymentTotal) return null;
    const breakdown = collection.lines[0].breakdown;
    if (!Number.isFinite(breakdown.unitBase) || breakdown.unitBase <= 0
      || !Number.isFinite(breakdown.placementFeesPerUnit) || breakdown.placementFeesPerUnit < 0) return null;

    examples.push({
      quantity,
      unitBaseInclVat: breakdown.unitBase,
      unitPrintInclVat: breakdown.placementFeesPerUnit,
      unitTotalInclVat: roundMoney(collection.paymentTotal / quantity),
      totalWithoutDeliveryInclVat: collection.paymentTotal,
      deliveryInclVat: delivery.deliveryCost,
      totalWithDeliveryInclVat: delivery.paymentTotal,
    });
  }
  return {
    product,
    configuration,
    productPath: PRINTED_CAPS_PRODUCT_PATH,
    frontWidthCm: printAreas[configuration.areaKey].maxWCm,
    frontHeightCm: printAreas[configuration.areaKey].maxHCm,
    examples,
  };
}
